import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "./Navbar";
import "./EmailManager.css";

const EmailManager = ({ onSubmit, showNavbar = true }) => {
  const [emailDestinataires, setEmailDestinataires] = useState([]);
  const [newEmail, setNewEmail] = useState("");
  const [newNom, setNewNom] = useState("");
  const [newPrenom, setNewPrenom] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [emailToDelete, setEmailToDelete] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState(null);

  const navigate = useNavigate();

  const fetchEmails = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/emailDestinataires`);
      setEmailDestinataires(response.data);
    } catch (error) {
      setErrorMessage("Erreur lors du chargement des emails.");
    }
  };

  useEffect(() => { fetchEmails(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newEmail || !newNom || !newPrenom) {
      setErrorMessage("Tous les champs sont obligatoires.");
      return;
    }

    const emailExiste = emailDestinataires.find(e => e.email === newEmail && e.id !== editId);
    if (emailExiste) {
      setErrorMessage("Cette adresse email existe déjà.");
      return;
    }

    try {
      if (editMode) {
        await axios.put(`${process.env.REACT_APP_API_URL}/emailDestinataires/${editId}`, {
          email: newEmail, nom: newNom, prenom: newPrenom
        });
        setSuccessMessage("Adresse email modifiée avec succès.");
      } else {
        await axios.post(`${process.env.REACT_APP_API_URL}/emailDestinataires`, {
          email: newEmail, nom: newNom, prenom: newPrenom
        });
        setSuccessMessage("Adresse email ajoutée avec succès.");
        setShowForm(false);
      }
      resetForm();
      fetchEmails();
    } catch {
      setErrorMessage("Erreur lors de l'enregistrement.");
    }
  };

  const resetForm = () => {
    setNewEmail(""); setNewNom(""); setNewPrenom("");
    setEditMode(false); setEditId(null); setErrorMessage("");
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/emailDestinataires/${id}`);
      setSuccessMessage("Adresse email supprimée.");
      fetchEmails();
    } catch {
      setErrorMessage("Erreur lors de la suppression.");
    }
  };

  return (
    <div>
      {showNavbar && <Navbar />}
      <div className="form-box">
        <h2 className="titre_formulaire">Gestion des Adresses Email</h2>

        <div className="form-actions">
          <button className="action-btn" onClick={() => { setShowForm(!showForm); resetForm(); }}>
            {showForm ? "Fermer le formulaire" : "➕ Ajouter une adresse"}
          </button>
        </div>

        {showForm && (
          <div className="email-form-container">
            <form onSubmit={handleSubmit}>
              {errorMessage && <p className="error-message">{errorMessage}</p>}
              {successMessage && <p className="success-message">{successMessage}</p>}
              <div className="form-group"><input type="text" placeholder="Nom" value={newNom} onChange={(e) => setNewNom(e.target.value)} required /></div>
              <div className="form-group"><input type="text" placeholder="Prénom" value={newPrenom} onChange={(e) => setNewPrenom(e.target.value)} required /></div>
              <div className="form-group"><input type="email" placeholder="Adresse email" value={newEmail} onChange={(e) => setNewEmail(e.target.value)} required /></div>

              <div id="colB">
                <div id="colC"><button className="btn btn-primary" type="submit">{editMode ? "Modifier" : "Enregistrer"}</button></div>
                <div id="colC"><button className="btn btn-secondary" type="button" onClick={() => { setShowForm(false); resetForm(); }}>Annuler</button></div>
              </div>
            </form>
          </div>
        )}


        <div className="email-form-container" style={{ position: 'relative', marginBottom: '20px' }}>
          <input
            className="form-group"
            type="text"
            placeholder="Rechercher un email par nom ou prénom"
            value={searchInput}
            onChange={(e) => {
              setSearchInput(e.target.value);
              setShowSuggestions(true);
              setSelectedEmail(null); // reset selection
            }}
            onFocus={() => setShowSuggestions(true)}
            autoComplete="off"
          />

          {showSuggestions && searchInput.length > 0 && (
            <ul className="autocomplete-list">
              {emailDestinataires
                .filter(dest =>
                  (`${dest.nom} ${dest.prenom} ${dest.email}`).toLowerCase().includes(searchInput.toLowerCase())
                )
                .slice(0, 5)
                .map(dest => (
                  <li
                    key={dest.id}
                    className="autocomplete-item"
                    onClick={() => {
                      setSelectedEmail(dest);
                      setSearchInput(`${dest.nom} ${dest.prenom}`);
                      setShowSuggestions(false);
                    }}
                  >
                    {dest.nom} {dest.prenom} — {dest.email}
                  </li>
                ))}
            </ul>
          )}
        </div>


        <div className="email-list">
          <div className="email-cards">
            {(selectedEmail ? [selectedEmail] : []).map((dest) => (
              <div key={dest.id} className="email-card">
                <p><strong>Nom:</strong> {dest.nom}</p>
                <p><strong>Prénom:</strong> {dest.prenom}</p>
                <p><strong>Email:</strong> {dest.email}</p>
                <div className="actions">
                  <button className="btn-edit" onClick={() => {
                    setNewEmail(dest.email);
                    setNewNom(dest.nom);
                    setNewPrenom(dest.prenom);
                    setEditMode(true);
                    setEditId(dest.id);
                    setShowForm(true);
                  }}>Modifier</button>
                  <button className="btn-delete" onClick={() => {
                    setEmailToDelete(dest.id);
                    setShowDeleteModal(true);
                  }}>Supprimer</button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {showDeleteModal && (
          <div className="modal">
            <div className="modal-content">
              <p>Confirmer la suppression ?</p>
              <button onClick={async () => { await handleDelete(emailToDelete); setShowDeleteModal(false); }}>Oui</button>
              <button onClick={() => setShowDeleteModal(false)}>Non</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailManager;
